<template>
    <div class="selection-box">
        <el-select v-model="selectValue" :placeholder="title">
            <el-option v-for="item in proList" :key="item.id" :label="item.value" :value="item.id"></el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            proList: this.list,
            title: this.list[0].value,
            selectValue: ''
        }
    },
    props:['list'],// 接收父组件传的值
    // 处理父级传入异步数据
    watch: {
        selectValue: function (val) {
            let itemArr = this.proList.filter(v => {
                return v.id == val;
            })
           this.$emit('screen',itemArr[0]);
        }
    },
    mounted () {
        console.log(this.list)    
    }
}
</script>

<style lang="scss">
    .selection-box{
        .el-input__inner{
            width: 120px;
            height: 32px;
            background: #EFF0F1;
            border-radius: 1px;
        }
        .el-input__icon{
            line-height: 32px;
        }
        .el-scrollbar__wrap{
            padding-bottom: 20px;
        }
    }
    
    .el-select-dropdown__item{
        font-size: 16px;
        height: 40px;
        line-height: 40px;
    }
    .el-select-dropdown__item.selected{
        color:$main-color;
    }

</style>